import React, { useEffect } from "react";
import { Grid } from "semantic-ui-react";
import RepeatableContainer from "../commonComponents/form/repeatableFormContainer";
import ReconStatusDetailLayout from "./ReconStatusDetailLayout";
import ReconStatusDetailRepeatable from "./ReconStatusDetailRepeatable";
import useApiHouse from "../../api/useApiHouse";
import { statusDetailPayload } from "../../api/apiPayloads";
import {  useSelector } from "react-redux";
import { initializeStatusDetail } from "../../slices/statusDetailSlice";
import { Dimmer, Loader, Image, Segment } from 'semantic-ui-react'
import useStatusDetail from "../../hooks/useStatusDetail";

const ReconStatusDetail = () => {
    const { getStatusDetail } = useStatusDetail();
    useEffect(() => {
        getStatusDetail();
    }, [])
    const {reconLoader: {statusDetailLoader: {statusDetailListLoader}}} = useSelector((state) => state.loader)
    return ( 
        <Grid className="status-detail">
            <Dimmer inverted active={statusDetailListLoader}>
                <Loader inverted content="Please Wait..." />
            </Dimmer>
            <RepeatableContainer 
                renderForm={(params) => <ReconStatusDetailRepeatable {...params} />}
                reducerName={"statusDetail"}
                keyName={"statusDetail"}
            />
        </Grid>
    );
}
 
export default ReconStatusDetail;